import { FilterOperatorInfo } from './filter-operator-info';
import { FilterOperators } from '../../domain-models/find-options/filter';
import { Subject } from 'rxjs';
import { ModifiedSubscriberInterface } from '../modified-subscriber.interface';

export class ZoomOperatorViewModelProperty {

  private static _defaultNotNullableOperators: Array<FilterOperatorInfo> = [
    new FilterOperatorInfo(FilterOperators.None, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.None)),
    new FilterOperatorInfo(FilterOperators.Equals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.Equals)),
    new FilterOperatorInfo(FilterOperators.NotEquals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.NotEquals)),
    new FilterOperatorInfo(FilterOperators.GreaterThan, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.GreaterThan)),
    new FilterOperatorInfo(FilterOperators.GreaterOrEqualThan, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.GreaterOrEqualThan)),
    new FilterOperatorInfo(FilterOperators.LessThan, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.LessThan)),
    new FilterOperatorInfo(FilterOperators.LessOrEqualThan, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.LessOrEqualThan)),
    new FilterOperatorInfo(FilterOperators.Between, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.Between)),
    new FilterOperatorInfo(FilterOperators.In, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.In))
  ];

  private static _defaultNullableOperators: Array<FilterOperatorInfo> = [
    new FilterOperatorInfo(FilterOperators.None, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.None)),
    new FilterOperatorInfo(FilterOperators.Equals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.Equals)),
    new FilterOperatorInfo(FilterOperators.NotEquals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.NotEquals)),
    new FilterOperatorInfo(FilterOperators.GreaterThan, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.GreaterThan)),
    new FilterOperatorInfo(FilterOperators.GreaterOrEqualThan, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.GreaterOrEqualThan)),
    new FilterOperatorInfo(FilterOperators.LessThan, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.LessThan)),
    new FilterOperatorInfo(FilterOperators.LessOrEqualThan, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.LessOrEqualThan)),
    new FilterOperatorInfo(FilterOperators.IsNull, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.IsNull)),
    new FilterOperatorInfo(FilterOperators.IsNotNull, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.IsNotNull)),
    new FilterOperatorInfo(FilterOperators.Between, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.Between)),
    new FilterOperatorInfo(FilterOperators.In, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.In))
  ];

  private static _defaultEnumOperators: Array<FilterOperatorInfo> = [
    new FilterOperatorInfo(FilterOperators.None, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.None)),
    new FilterOperatorInfo(FilterOperators.Equals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.Equals)),
    new FilterOperatorInfo(FilterOperators.NotEquals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.NotEquals)),
    new FilterOperatorInfo(FilterOperators.In, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.In))
  ];

  private static _stringOperators: Array<FilterOperatorInfo> = [
    new FilterOperatorInfo(FilterOperators.None, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.None)),
    new FilterOperatorInfo(FilterOperators.Equals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.Equals)),
    new FilterOperatorInfo(FilterOperators.NotEquals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.NotEquals)),
    new FilterOperatorInfo(FilterOperators.GreaterThan, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.GreaterThan)),
    new FilterOperatorInfo(FilterOperators.GreaterOrEqualThan, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.GreaterOrEqualThan)),
    new FilterOperatorInfo(FilterOperators.LessThan, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.LessThan)),
    new FilterOperatorInfo(FilterOperators.LessOrEqualThan, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.LessOrEqualThan)),
    new FilterOperatorInfo(FilterOperators.IsNull, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.IsNull)),
    new FilterOperatorInfo(FilterOperators.IsNotNull, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.IsNotNull)),
    new FilterOperatorInfo(FilterOperators.Contains, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.Contains), false),
    new FilterOperatorInfo(FilterOperators.StartWith, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.StartWith)),
    new FilterOperatorInfo(FilterOperators.EndWith, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.EndWith)),
    new FilterOperatorInfo(FilterOperators.Between, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.Between)),
    new FilterOperatorInfo(FilterOperators.In, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.In))
  ];

  private static _limitedOperators: Array<FilterOperatorInfo> = [
    new FilterOperatorInfo(FilterOperators.None, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.None)),
    new FilterOperatorInfo(FilterOperators.Equals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.Equals)),
    new FilterOperatorInfo(FilterOperators.NotEquals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.NotEquals)),
  ];

  private static _internalOperators: Array<FilterOperatorInfo> = [
    new FilterOperatorInfo(FilterOperators.None, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.None)),
  ];

  private static _boolOperators: Array<FilterOperatorInfo> = [
    new FilterOperatorInfo(FilterOperators.None, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.None)),
    new FilterOperatorInfo(FilterOperators.Equals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.Equals))
  ];

  private static _guidOperators: Array<FilterOperatorInfo> = [
    new FilterOperatorInfo(FilterOperators.None, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.None)),
    new FilterOperatorInfo(FilterOperators.Equals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.Equals)),
    new FilterOperatorInfo(FilterOperators.NotEquals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.NotEquals)),
  ];

  private static _nullableBoolOperators: Array<FilterOperatorInfo> = [
    new FilterOperatorInfo(FilterOperators.None, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.None)),
    new FilterOperatorInfo(FilterOperators.Equals, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.Equals)),
    new FilterOperatorInfo(FilterOperators.IsNull, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.IsNull)),
    new FilterOperatorInfo(FilterOperators.IsNotNull, ZoomOperatorViewModelProperty.getLocalizedEnumShortName(FilterOperators.IsNotNull))
  ];

  operatorChanged: Subject<FilterOperators> = new Subject<FilterOperators>();
  operatorEnableStatusChanged: Subject<boolean> = new Subject<boolean>();

  // Eventi per cambiamento valori degli operatori
  operatorValuesChanged: Subject<void> = new Subject();
  advancedOperatorValuesChanged: Subject<boolean> = new Subject<boolean>();

  modifiedSubscriber: ModifiedSubscriberInterface;

  values: Array<FilterOperatorInfo>;

  private _currentValue: FilterOperators;
  private _isEnabled: boolean;

  static get operatorsForInternalCollection(): Array<FilterOperatorInfo> {
    return ZoomOperatorViewModelProperty._internalOperators;
  }

  static get operatorsForInternal(): Array<FilterOperatorInfo> {
    return ZoomOperatorViewModelProperty._internalOperators;
  }

  static get operatorsForString(): Array<FilterOperatorInfo> {
    return ZoomOperatorViewModelProperty._stringOperators;
  }

  static get operatorsForEnum(): Array<FilterOperatorInfo> {
    return ZoomOperatorViewModelProperty._defaultEnumOperators;
  }

  static get operatorsForNumeric(): Array<FilterOperatorInfo> {
    return ZoomOperatorViewModelProperty._defaultNotNullableOperators;
  }

  static get operatorsForExternal(): Array<FilterOperatorInfo> {
    return ZoomOperatorViewModelProperty._defaultNullableOperators;
  }

  static get operatorsForFieldWithRelation(): Array<FilterOperatorInfo> {
    return ZoomOperatorViewModelProperty._limitedOperators;
  }

  static get operatorsForNNumeric(): Array<FilterOperatorInfo> {
    return ZoomOperatorViewModelProperty._defaultNullableOperators;
  }

  static get operatorsForDateTime(): Array<FilterOperatorInfo> {
    return ZoomOperatorViewModelProperty._defaultNotNullableOperators;
  }

  static get operatorsForNDateTime(): Array<FilterOperatorInfo> {
    return ZoomOperatorViewModelProperty._defaultNullableOperators;
  }

  static get operatorsForBool(): Array<FilterOperatorInfo> {
    return ZoomOperatorViewModelProperty._boolOperators;
  }

  static get operatorsForGuid(): Array<FilterOperatorInfo> {
    return ZoomOperatorViewModelProperty._guidOperators;
  }

  static get operatorsForNBool(): Array<FilterOperatorInfo> {
    return ZoomOperatorViewModelProperty._nullableBoolOperators;
  }

  private static getLocalizedEnumShortName(enumValue: FilterOperators): string {
    // return FilterOperators[enumValue];

    if (enumValue === FilterOperators.None) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_None);
      return 'Nessuno';
    } else if (enumValue === FilterOperators.Equals) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_Equals);
      return 'Uguale a';
    } else if (enumValue === FilterOperators.NotEquals) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_NotEquals);
      return 'Diverso da';
    } else if (enumValue === FilterOperators.GreaterThan) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_GreaterThan);
      return 'Maggiore di';
    } else if (enumValue === FilterOperators.GreaterOrEqualThan) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_GreaterOrEqualThan);
      return 'Maggiore uguale di';
    } else if (enumValue === FilterOperators.LessThan) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_LessThan);
      return 'Minore di';
    } else if (enumValue === FilterOperators.LessOrEqualThan) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_LessOrEqualThan);
      return 'Minore uguale di';
    } else if (enumValue === FilterOperators.IsNull) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_IsNull);
      return 'Non è valorizzato';
    } else if (enumValue === FilterOperators.IsNotNull) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_IsNotNull);
      return "E' valorizzato";
    } else if (enumValue === FilterOperators.Contains) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_Contains);
      return 'Contiene';
    } else if (enumValue === FilterOperators.StartWith) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_StartWith);
      return 'Inizia per';
    } else if (enumValue === FilterOperators.EndWith) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_EndWith);
      return 'Finisce per';
    } else if (enumValue === FilterOperators.Between) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_Between);
      return 'Compreso tra';
    } else if (enumValue === FilterOperators.In) {
      // return MessageResourceManager.Current.getMessage(MessageCodes.FilterOperators_In);
      return 'Uno di';
    }
    return '';
  }

  get currentValue(): FilterOperators {
    return this._currentValue;
  }

  set currentValue(value: FilterOperators) {
    if (this._currentValue != value) {
      this._currentValue = value;
      this.operatorChanged.next(value);
      this.modifiedSubscriber.notifyModified();
    }    
  }

  get isEnabled(): boolean {
    return this._isEnabled;
  }

  set isEnabled(isEnabled: boolean) {
    if (this._isEnabled != isEnabled) {
      this._isEnabled = isEnabled;
      this.operatorEnableStatusChanged.next(isEnabled);
    }    
  }

  constructor(operatorList: Array<FilterOperatorInfo>, modifiedSubscriber: ModifiedSubscriberInterface) {
    this.values = operatorList;
    this.modifiedSubscriber = modifiedSubscriber;
    this.currentValue = FilterOperators.None;
    this.isEnabled = true;
  }

}
